import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Assets/History'

export default createChildListViewContainer()(Component)
